<cac-dialog-layout
  [title]="data.category ? 'Edit Category' : 'Create New Category'"
  subtitle="Enter the required data and save"
  (onSubmit)="onSubmit($event)"
>
  <cac-image-uploader [control]="image" [options]="options" class="h-44" />
  <cac-form-builder [options]="form" class="mt-5" />

  <div class="mt-5">
    <label for="colorPicker" class="block text-sm font-medium mb-2">Color</label>
    <div class="flex items-center gap-2">
      <input type="color" id="colorPicker" [formControl]="color" class="h-10 w-20 cursor-pointer border-0 rounded" />
      <input type="text" [formControl]="color" placeholder="#RRGGBB" class="border rounded px-3 py-2 w-32" />
    </div>
  </div>
</cac-dialog-layout>
